import { MenuIcon } from '@/src/assets/icons/MenuIcon'
import { Link } from 'expo-router'
import { TouchableOpacity } from 'react-native'
import { styled } from 'tamagui'

const StyledMenuIcon = styled(MenuIcon, {
  color: '$textDark',
  height: 32,
  width: 32,
})

export function MenuButton() {
  return (
    <Link href="/main/menu" push asChild>
      <TouchableOpacity activeOpacity={0.5}>
        <StyledMenuIcon />
      </TouchableOpacity>
    </Link>
  )
}
